'use strict'

import Barba from 'barba.js';
import {TweenLite, TimelineLite} from 'gsap';
import Swiper from './swiper';
import st from './scrollto';
import Accordion from './accordion';


let self

export default self = {

  init : () => {
    Barba.Pjax.init();
    Barba.Prefetch.init();

    // Google Analytics
    Barba.Dispatcher.on('initStateChange', function() {
      if (typeof ga === 'function') {
        ga('send', 'pageview', location.pathname);
      }
    });

    let lastElementClicked;

    Barba.Dispatcher.on('linkClicked', function(el) {
      lastElementClicked = el;
    });


    //---------------------------------------//
    //      Buyer Seller Landing Page        //
    //---------------------------------------//
    const BuyerSeller = Barba.BaseView.extend({
        namespace: "buyer-seller-landing",
        onEnter: function() {
            this._construct()
        },
        onEnterCompleted: function() {
            this.start()
        },
        Swiper: null,
        _construct: function() {
            this.destroy();

            this.Swiper = Swiper;
            this.Swiper.init();
        },
        exit: function() {
            this.Swiper = null;
        },
        destroy: function() {
            this.Swiper = null;
        },
        start: function() {
            this.Swiper = Swiper;
            this.Swiper.init();
        }
    });
    BuyerSeller.init();


    //---------------------------------------//
    //      Buyer Seller Steps Page        //
    //---------------------------------------//
    const Steps = Barba.BaseView.extend({
        namespace: "buyer-seller-steps",
        onEnter: function() {
            this._construct()
        },
        onEnterCompleted: function() {
            this.start()
        },
        Accordion: null,
        _construct: function() {
            this.destroy();

            this.Accordion = Accordion;
            this.Accordion.init();
        },
        exit: function() {
            this.Accordion = null;
        },
        destroy: function() {
            this.Accordion = null;
        },
        start: function() {
            this.Accordion = Accordion;
            this.Accordion.init();
        }
    });
    Steps.init();


    //---------------------------------------//
    //            Page Transition            //
    //---------------------------------------//
    const PageAnimation = Barba.BaseTransition.extend({
      start: function() {

        if(lastElementClicked.classList.contains('step-list__link')){
          Promise
            .all([this.newContainerLoading])
            .then(this.circleExpand.bind(this));
        }else if(lastElementClicked.dataset.btn){
          Promise
            .all([this.newContainerLoading])
            .then(this.fadeInSlide.bind(this));
        }else {
          Promise
            .all([this.newContainerLoading])
            .then(this.fadeOut.bind(this));
        };
      },

      fadeOut: function() {
        const _this = this;
        const tlCover = new TimelineLite();

        return tlCover
        .to(this.oldContainer, 0.5, {autoAlpha: 0, display: 'none'})
        .to(this.newContainer, 0.5, {autoAlpha: 1, onComplete: function() {
          TweenLite.set(_this.newContainer, { clearProps: 'all' });
          _this.done();
        }});

      },

      fadeInSlide: function() {
        const _this = this;
        const tlCover = new TimelineLite();

        return tlCover
        .to(this.oldContainer, 0.5, {autoAlpha: 0, display: 'none'})
        .add( function(){ st.animate(0, 100)} )
        .to(this.newContainer, 0.5, {autoAlpha: 1})
        .from(this.newContainer.querySelector('.step-image-container'), 0.5, {x: '-40px', autoAlpha: 0}, '-=0.3')
        .add('in-=0.3')
        .from(this.newContainer.querySelector('.pagination'), 0.5, {x: '-40px', autoAlpha: 0}, 'in')
        .from(this.newContainer.querySelector('.resources'), 0.5, {x: '-40px', autoAlpha: 0, onComplete: function() {
          TweenLite.set(_this.newContainer, { clearProps: 'all' });
          _this.done();
        }}, 'in');

      },

      circleExpand: function() {
        const _this = this;
        const circle = lastElementClicked.lastElementChild;
        const header = document.querySelector('header');

        const tlCircle = new TimelineLite();

        return tlCircle
        .set(circle, {autoAlpha: 1})
        .set(header, {zIndex: 0})
        .to(circle, 1.6, {scale: 1})
        .to(_this.oldContainer, 0.01, {display: 'none'}, '-=0.6')
        .add( function(){ st.animate(0, 100)}, '-=0.6')
        .add('in', '-=0.4')
        .to(circle, 0.01, {autoAlpha: 0}, 'in')
        .from(_this.newContainer, 1, {autoAlpha: 0}, 'in')
        .from(header, 0.5, {y: '-20px', autoAlpha: 0}, 'in')
        .from('.step-image-container', 0.5, {x: '-40px', autoAlpha: 0}, 'in+=0.3')
        .from(this.newContainer.querySelector('.pagination'), 0.5, {x: '-40px', autoAlpha: 0}, 'in+=0.5')
        .from('.resources', 0.5, {x: '-40px', autoAlpha: 0, onComplete: function() {
          TweenLite.set(_this.newContainer, { clearProps: 'all' });
          TweenLite.set(circle, { clearProps: 'all' });
          TweenLite.set(header, { clearProps: 'all' });
          _this.done();
        }}, 'in+=0.5');
;

      }
    });

    Barba.Pjax.getTransition = function() {
      return PageAnimation;
    };


  }
}
